@if (komponenter.length > 0) {
  <div class="margin-top">
    <h2 class="flex-wrap flex-wrap--flex-start">
      Komponenter
      <app-info tooltip="Komponenten er den specifikke bestanddel af et anlæg (eksempelvis en keddel)." inline="true"></app-info>
    </h2>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0 simple-table">
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let komponent">
          <div>{{ komponent.komponentTypeTekst }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="model">
        <th mat-header-cell *matHeaderCellDef>Model</th>
        <td mat-cell *matCellDef="let komponent" [matTooltip]="'Model: ' + komponent.model" class="cursor-help">
          <div class="ellipsis block">{{ komponent.model }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="installationDate">
        <th mat-header-cell *matHeaderCellDef>Installeret</th>
        <td mat-cell *matCellDef="let komponent">
          <div>{{ komponent.installationDate | date: 'dd.MM.yyyy' }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="garantiPeriode">
        <th mat-header-cell *matHeaderCellDef>Garanti</th>
        <td mat-cell *matCellDef="let komponent">
          @if (komponent.installationDate && komponent.garantiPeriode) {
            <div
              [matTooltip]="komponent.garantiPeriode + ' måneder'"
              class="cursor-help"
              >
              {{ getGarantiEndDate(komponent.installationDate, komponent.garantiPeriode) | date: 'dd.MM.yyyy' }}
            </div>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="serienummer">
        <th mat-header-cell *matHeaderCellDef>Serienr.</th>
        <td mat-cell *matCellDef="let komponent" [matTooltip]="'Snr.: ' + komponent.serienummer" class="cursor-help">
          <div class="ellipsis block">{{ komponent.serienummer }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="rowActions">
        <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let komponent; index as i">
          <div class="hidden-cell">
            <button
              [disabled]="!canWrite"
              (click)="editKomponent.emit(komponent)"
              class="btn-icon blue"
              aria-label="Rediger komponent"
              matTooltip="Rediger komponent"
              >
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
            <button
              [disabled]="!canWrite"
              (click)="deleteKomponent.emit(komponent)"
              class="btn-icon red"
              aria-label="Slet komponent"
              matTooltip="Slet komponent"
              >
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="activeColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: activeColumns"></tr>
    </table>
  </div>
}
<div class="margin-top">
  <button type="button" class="btn-icon btn-add-small blue" (click)="addKomponent.emit()" [disabled]="!canWrite">
    <mat-icon svgIcon="add-small"></mat-icon>
    <span>Tilføj komponent</span>
  </button>
</div>
